import React, { useEffect, useState, useCallback } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { messEnrollList } from "../../api/Mess";
import Master from "./Master";
import { printElement } from "../master/Print";
import MessGuestCard1 from "../components/MessGuestCard1";
import { useLocation } from "react-router-dom";

export default function MessGuestCard() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const getDataList = useCallback(async () => {
    if (!id) return null;
    setLoading(true);
    let addUrl = `limit=all&id=${id}`;
    try {
      const response = await messEnrollList(addUrl);
      if (response.data?.status) {
        setData(response?.data?.data?.[0]);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getDataList();
  }, [getDataList]);

  const styles=`
    @page { size: 95mm 65mm; margin: 0; }
            body { margin: 0; }
  .mess-id-card-horizontal-1 {
  width: 95mm !important;
  height: 65mm !important;
  border: 2pt solid rgba(255, 0, 0, 0.688) !important;
  border-radius: 10px;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

.mess-id-card-horizontal-1 .institute-details {
  font-size: 10px;
  font-weight: bold;
  color: black;
  text-wrap: nowrap;
}

.mess-id-card-horizontal-1 .institute-details h6 {
  font-weight: 900 !important;
  color: rgba(255, 0, 0) !important;
  font-size: 22px;
}

.mess-id-card-horizontal-1 div {
  font-size: 14px;
  color: black;
  font-weight: bold;
}

.mess-id-card-horizontal-1 .card_name {
  font-weight: 500 !important;
  background-color: rgba(255, 0, 0, 0.662) !important;
  padding: 1px 3px;
  color: white;
  border-radius: 2px;
}


.mess-id-card-horizontal-1 .col-1 {
  width: 2% !important;
}

.mess-id-card-horizontal-1 .border {
  border: 1pt solid rgba(255, 0, 0, 0.688) !important;
}

.mess-id-card-horizontal-1 .border-top {
  border-top: 1pt solid rgba(255, 0, 0, 0.688) !important;
}

.mess-id-card-horizontal-1 .profile-img {
  width: 80px !important;
  height: 100px !important;
  content: cover;
  object-fit: cover;
}

.mess-id-card-horizontal-1::before {
  content: "";
  position: absolute;
  inset: 0;
  background-repeat: no-repeat;
  background-position: 30% center;
  background-size: 150px;
  opacity: 0.4;
  z-index: -1;
}

.mess-id-card-horizontal-1 .admission-date {
  position: absolute;
  right: 10px;
  top: 80%;
  transform: rotate(90deg) translateY(-50%);
  transform-origin: right top;
  font-size: 10px;
  font-weight: bold;
  white-space: nowrap;
}

.mess-id-card-horizontal-1 .signature {
  position: absolute;
  right: 12px;
  bottom: 1px;
  font-size: 12px;
  white-space: nowrap;

}

.mess-id-card-horizontal-1 .signature img {
  width: 80px !important;
  margin-right: 10px;

}

.mess-id-card-horizontal-1 .signature p {
  margin: 0 12px 6px 0 !important;
}`;
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <Master />
                  <div className="col-10">
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="text-primary mb-0">
                              Mess Guest Card
                            </h4>
                          </div>
                          <div className="col-6 text-end">
                            <button
                              className="btn btn-outline-info"
                              onClick={() => printElement("PrintDiv",styles)}
                            >
                              Print
                            </button>
                          </div>
                        </div>

                        <hr />
                        <div id="PrintDiv">{data && <MessGuestCard1 data={data} />}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
